import axios from 'helpers/axios';
import config from '../../config';

const createEmailTemplateRequest = (data) => {
  const { groupName, locale } = data;

  return axios({
    method: 'post',
    url: `${config.apiUrl}/emailTemplates`,
    data: {
      subject: '',
      body: '',
      category: groupName,
      language: locale,
    }
  });
};

const deleteEmailTemplateRequest = ({ id }) => axios({
  method: 'delete',
  url: `${config.apiUrl}/emailTemplates/${id}`
});

const updateEmailTemplateRequest = data => axios({
  method: 'patch',
  url: `${config.apiUrl}/emailTemplates/${data.id}`,
  data
});

export { createEmailTemplateRequest, updateEmailTemplateRequest, deleteEmailTemplateRequest };
